import React, { FC } from 'react'
import { Button, Modal } from 'UI'
import { ModalHeight, ModalSize } from 'UI/Modal/types'
import { ButtonStyles } from 'UI/Button/types'
import { ValidationSuccessMessages } from 'types'

import { useNavigate } from 'react-router-dom'
import cl from './style.module.scss'

interface CopyModalProps {
	isOpen: boolean
	courseTitle: string
	onClose: () => void
}

const CopyModal: FC<CopyModalProps> = ({
	isOpen,
	courseTitle,
	onClose
}) => {
	const navigate = useNavigate()
	return (
		<Modal
			onClose={onClose}
			isOpen={isOpen}
			styleTypes={[ModalSize.BIG, ModalHeight.SMALL]}
			title={ValidationSuccessMessages.COPY_COURSE_SUCCESS}
			description={`Вы можете найти курс "${courseTitle}" в разделе "Черновики" `}
		>
			<div className={cl.buttonsContainer}>
				<Button
					onClick={() => {
						navigate('/')
						onClose()
					}}
					styleTypes={[ButtonStyles.DARK, ButtonStyles.ROUND]}
				>
					Перейти к списку курсов
				</Button>
			</div>
		</Modal>
	)
}

export default CopyModal
